export default {"src":"/_next/static/media/thehomedepot.9f5464f2.svg","height":80,"width":180,"blurWidth":0,"blurHeight":0};